import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  CustomTooltipModule,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { BrandLinks } from '@principle-theorem/principle-core';
import {
  IMarketingCampaign,
  IMarketingCampaignEntry,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef } from '@principle-theorem/shared';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BrandRouterLinkDirective } from '../../../../navigation/brand-router-link.directive';
import {
  CampaignEntryManagementService,
  IEntryAction,
} from '../../campaign-entry-management.service';
import { CampaignEntryProgressComponent } from '../../campaign-entry-progress/campaign-entry-progress.component';
import { CampaignEntryStatusComponent } from '../../campaign-entry-status/campaign-entry-status.component';

@Component({
  selector: 'pr-patient-marketing-campaign',
  templateUrl: './patient-marketing-campaign.component.html',
  styleUrl: './patient-marketing-campaign.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
  imports: [
    NgCommonModule,
    RouterModule,
    BrandRouterLinkDirective,
    CustomTooltipModule,
    CampaignEntryProgressComponent,
    CampaignEntryStatusComponent,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule,
  ],
  providers: [CampaignEntryManagementService],
})
export class PatientMarketingCampaignComponent {
  entryService = inject(CampaignEntryManagementService);
  brandLinks = BrandLinks;

  entry = input.required<WithRef<IMarketingCampaignEntry>>();

  menuActions$: Observable<IEntryAction[]> = toObservable(this.entry).pipe(
    switchMap((entry) => this.entryService.getActions$(entry)),
    map((actions) => {
      const allActions: IEntryAction[] = [];
      if (actions.primary) {
        allActions.push(actions.primary);
      }
      allActions.push(...actions.secondary);
      return allActions;
    })
  );

  getCampaign$(
    entry: WithRef<IMarketingCampaignEntry>
  ): Observable<WithRef<IMarketingCampaign>> {
    return Firestore.doc$(entry.campaignRef);
  }
}
